import { render } from "./OverlayLoader.vue?vue&type=template&id=40459b67&scoped=true&ts=true"
import script from "./OverlayLoader.vue?vue&type=script&lang=ts"
export * from "./OverlayLoader.vue?vue&type=script&lang=ts"

import "./OverlayLoader.vue?vue&type=style&index=0&id=40459b67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40459b67"],['__file',"src/components/Others/OverlayLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40459b67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40459b67', __exports__)) {
    api.reload('40459b67', __exports__)
  }
  
  module.hot.accept("./OverlayLoader.vue?vue&type=template&id=40459b67&scoped=true&ts=true", () => {
    api.rerender('40459b67', render)
  })

}


export default __exports__